import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HorizontalMenuItem, MenuItem } from '../../../interfaces/menu.interface';

import { CommonModule } from '@angular/common';
import { SectionsService } from '../../../services/sections.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { ListService } from '../../../shared/services/list.service';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { LeadDetailSummaryComponent } from "../summary/lead-detail-summary/lead-detail-summary.component";
import { LeadInformationComponent } from "../participant-information/lead-information/lead-information.component";
import { FormChecklistComponent } from "../../leads/form-checklist/form-checklist.component";
import { AuthorizationComponent } from "../authorization/authorization.component";
import { AssociationsComponent } from "../associations/associations.component";
import { AdditionalAttributesComponent } from "../additional-attributes/additional-attributes.component";

@Component({
  selector: 'ppl-member-wrapper-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    AuthorizeDirective,
    ButtonComponent,
    LeadDetailSummaryComponent,
    LeadInformationComponent,
    FormChecklistComponent,
    AuthorizationComponent,
    AssociationsComponent,
    AdditionalAttributesComponent
],
  providers: [ListService],
  templateUrl: './member-wrapper-view.component.html',
  styleUrl: './member-wrapper-view.component.css',
})
export class MemberViewComponent extends BaseComponent implements OnInit, OnDestroy {
  horizontalMenuItemstoDisplay: any;
  selectedMenuItem: any;
  enableComments = false;
  changedCLass = '';
  filledInfo: any;
  id: any;
  applicationData: any[] = [];
  listButton: any[] = [];

  applicationStatusList: any;
  entry: any;
  sectionDataPath: string = STATIC_JSON_DATA_PATH.LEAD_DETAILS_SECTION_DATA;
  program: any;
  pageId = '';
  tabId = '';
  steps: any;
  showSMSModal: any = '';
  notificationType = '';
  mobileNumber: string[] = [];
  emailId: string[] = [];
  isPageRestrictionLoaded = false;
  auditHistory: any;
  backLabel = "Back";
  leadData: any;
  isCommunicationLogs = false;
  isExternalEnvironment = false;

  constructor(
    private router: Router,
    private sectionsService: SectionsService,
    private userService: UserService,
  ) {
    super();
  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.isExternalEnvironment = environment.isExternal;
    this.program = this.userService.getSelectedProgram();
    this.entry = this.userService.getLeadEntry();
    this.id = JSON.parse(this.userService.getSelectedLead()!);
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.getMenuItems();
  }


  async getMenuItems() {
    try {
      if (this.entry) {
        const menu = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_MENU,
          this.entry
        );
        this.horizontalMenuItemstoDisplay = this.filterHorizontalMenuItems(
          menu.horizontal_menu
        );

        const navigateToTab = history?.state?.['navigateToTab'];
        const foundTab = this.horizontalMenuItemstoDisplay.find((menuItem: MenuItem) => {
          return menuItem?.menu_id?.toLowerCase() === (navigateToTab?.toLowerCase() || this.horizontalMenuItemstoDisplay[0]?.menu_id?.toLowerCase());
        });

        this.selectedMenuItem = foundTab?.menu_id?.toLocaleLowerCase();
      }
    } catch (e) {
      console.log('error fetching menu items: ', e);
    }
  }

  filterHorizontalMenuItems = (menu: HorizontalMenuItem): MenuItem[] => {
    const allowedMenuIds = ['summary', 'enrollmentinformation', 'authorizations', 'forms', 'additionalattributes', 'associations'];

    return menu.filter((menuItem: MenuItem) =>
      menuItem.display === 'y' &&
      allowedMenuIds.includes(menuItem.menu_id.toLowerCase())
    );
  };

  onMenuSelection = (menuSelected: any) => {
    this.selectedMenuItem = menuSelected.menu_id.toLocaleLowerCase();
  };
}
